var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewCardOptionPhysical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 312,
    viewBox: "0 0 212 312",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 212,
    height: 312,
    rx: 20,
    fill: "#07132B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8507 46.7431H27.479L30.3424 36.3283L33.2058 46.7431H35.8342L40.6849 30.2569H37.3727L34.488 40.6016L31.6673 30.2569H29.0389L26.2183 40.5783L23.3335 30.2569H20L24.8507 46.7431Z",
    fill: "#ECF7FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9072 33.5198V46.7429H45.2621V33.5198H41.9072Z",
    fill: "#ECF7FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2746 30.2569H46.5498V33.456H51.2723V46.7431H54.6272V33.456H59.3496V30.2569H54.625V33.4555H51.2746V30.2569Z",
    fill: "#ECF7FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6357 46.7431H63.9906V39.8544H69.9739V46.7431H73.3501V30.2569H69.9739V36.6786H63.9906V30.2569H60.6357V46.7431Z",
    fill: "#ECF7FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6416 43.5215H78.9961V46.7431H85.6849V43.5206H78.9965V30.2569H75.6416V43.5215Z",
    fill: "#ECF7FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.8701 46.7431H87.0361V46.7431H90.3887V43.571H87.0361V30.2569H97.7632V33.4093H90.391V36.7953H97.1221V39.8544H90.391V43.5673H97.8701V46.7431Z",
    fill: "#ECF7FB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.729 47C107.362 47 109.52 45.1085 109.52 41.956C109.52 35.9547 102.447 37.3791 102.447 34.5069C102.447 33.5962 103.152 33.1058 104.349 33.1058C105.503 33.1058 106.4 33.5962 107.298 34.6236L109.477 32.2651C108.345 30.8874 106.529 30 104.413 30C101.293 30 99.1136 31.8214 99.1136 34.8571C99.1136 40.6484 106.187 39.1772 106.187 42.283C106.187 43.2637 105.353 43.8709 103.943 43.8709C102.362 43.8709 101.229 43.1937 100.267 41.956L98.0879 44.3146C99.5623 46.136 101.25 47 103.729 47Z",
    fill: "#ECF7FB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.21 47C118.842 47 121.001 45.1085 121.001 41.956C121.001 35.9547 113.928 37.3791 113.928 34.5069C113.928 33.5962 114.633 33.1058 115.829 33.1058C116.983 33.1058 117.881 33.5962 118.778 34.6236L120.958 32.2651C119.825 30.8874 118.009 30 115.893 30C112.774 30 110.594 31.8214 110.594 34.8571C110.594 40.6484 117.667 39.1772 117.667 42.283C117.667 43.2637 116.834 43.8709 115.423 43.8709C113.842 43.8709 112.71 43.1937 111.748 41.956L109.568 44.3146C111.043 46.136 112.731 47 115.21 47Z",
    fill: "#ECF7FB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M174.661 266.803H186.269V287.407H174.661V266.803Z",
    fill: "#FF5F00"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M175.399 277.105C175.399 272.919 177.388 269.206 180.447 266.803C178.199 265.056 175.362 264 172.266 264C164.933 264 159 269.861 159 277.105C159 284.35 164.933 290.211 172.266 290.211C175.362 290.211 178.199 289.155 180.447 287.407C177.388 285.041 175.399 281.292 175.399 277.105Z",
    fill: "#EB001B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M201.931 277.105C201.931 284.349 195.998 290.211 188.665 290.211C185.57 290.211 182.732 289.155 180.484 287.407C183.58 285.005 185.533 281.292 185.533 277.105C185.533 272.919 183.543 269.206 180.484 266.803C182.732 265.056 185.57 264 188.665 264C195.998 264 201.931 269.897 201.931 277.105Z",
    fill: "#F79E1B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 24.624 82.5465)",
    fill: "#202B40"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 20 82.5465)",
    fill: "#202B40"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 23.2363 82.7033)",
    fill: "#202B40"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 23.2363 78)",
    fill: "#202B40"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 51.8105 82.5465)",
    fill: "#202B40"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 47.1865 82.5465)",
    fill: "#202B40"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 50.4229 82.7033)",
    fill: "#202B40"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 50.4229 78)",
    fill: "#202B40"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 78.9961 82.5465)",
    fill: "#202B40"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 74.3721 82.5465)",
    fill: "#202B40"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 77.6084 82.7033)",
    fill: "#202B40"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 77.6084 78)",
    fill: "#202B40"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 106.183 82.5465)",
    fill: "#202B40"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 101.559 82.5465)",
    fill: "#202B40"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 104.795 82.7033)",
    fill: "#202B40"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 104.795 78)",
    fill: "#202B40"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 133.369 82.5465)",
    fill: "#202B40"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 128.745 82.5465)",
    fill: "#202B40"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 131.981 82.7033)",
    fill: "#202B40"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 131.981 78)",
    fill: "#202B40"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 160.555 82.5465)",
    fill: "#202B40"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 155.931 82.5465)",
    fill: "#202B40"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 159.167 82.7033)",
    fill: "#202B40"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 159.167 78)",
    fill: "#202B40"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 187.741 82.5465)",
    fill: "#202B40"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 183.117 82.5465)",
    fill: "#202B40"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 186.354 82.7033)",
    fill: "#202B40"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 186.354 78)",
    fill: "#202B40"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 24.624 108.385)",
    fill: "#202B40"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 20 108.385)",
    fill: "#202B40"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 23.2363 108.542)",
    fill: "#202B40"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 23.2363 103.839)",
    fill: "#202B40"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 51.8105 108.385)",
    fill: "#202B40"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 47.1865 108.385)",
    fill: "#202B40"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 50.4229 108.542)",
    fill: "#202B40"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 50.4229 103.839)",
    fill: "#202B40"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 78.9961 108.385)",
    fill: "#202B40"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 74.3721 108.385)",
    fill: "#202B40"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 77.6084 108.542)",
    fill: "#202B40"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 77.6084 103.839)",
    fill: "#202B40"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 106.183 108.385)",
    fill: "#202B40"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 101.559 108.385)",
    fill: "#202B40"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 104.795 108.542)",
    fill: "#202B40"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 104.795 103.839)",
    fill: "#202B40"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 133.369 108.385)",
    fill: "#202B40"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 128.745 108.385)",
    fill: "#202B40"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 131.981 108.542)",
    fill: "#202B40"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 131.981 103.839)",
    fill: "#202B40"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 160.555 108.385)",
    fill: "#202B40"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 155.931 108.385)",
    fill: "#202B40"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 159.167 108.542)",
    fill: "#202B40"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 159.167 103.839)",
    fill: "#202B40"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 187.741 108.385)",
    fill: "#202B40"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 183.117 108.385)",
    fill: "#202B40"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 186.354 108.542)",
    fill: "#202B40"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 186.354 103.839)",
    fill: "#202B40"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 24.624 134.224)",
    fill: "#202B40"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 20 134.224)",
    fill: "#202B40"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 23.2363 134.381)",
    fill: "#202B40"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 23.2363 129.678)",
    fill: "#202B40"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 51.8105 134.224)",
    fill: "#202B40"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 47.1865 134.224)",
    fill: "#202B40"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 50.4229 134.381)",
    fill: "#202B40"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 50.4229 129.678)",
    fill: "#202B40"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 78.9961 134.224)",
    fill: "#202B40"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 74.3721 134.224)",
    fill: "#202B40"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 77.6084 134.381)",
    fill: "#202B40"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 77.6084 129.678)",
    fill: "#202B40"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 106.183 134.224)",
    fill: "#202B40"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 101.559 134.224)",
    fill: "#202B40"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 104.795 134.381)",
    fill: "#202B40"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 104.795 129.678)",
    fill: "#202B40"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 133.369 134.224)",
    fill: "#202B40"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 128.745 134.224)",
    fill: "#202B40"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 131.981 134.381)",
    fill: "#202B40"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 131.981 129.678)",
    fill: "#202B40"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 160.555 134.224)",
    fill: "#202B40"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 155.931 134.224)",
    fill: "#202B40"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 159.167 134.381)",
    fill: "#202B40"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 159.167 129.678)",
    fill: "#202B40"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 187.741 134.224)",
    fill: "#202B40"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 183.117 134.224)",
    fill: "#202B40"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 186.354 134.381)",
    fill: "#202B40"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 186.354 129.678)",
    fill: "#202B40"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 24.624 160.063)",
    fill: "#202B40"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 20 160.063)",
    fill: "#202B40"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 23.2363 160.22)",
    fill: "#202B40"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 23.2363 155.517)",
    fill: "#202B40"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 51.8105 160.063)",
    fill: "#202B40"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 47.1865 160.063)",
    fill: "#202B40"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 50.4229 160.22)",
    fill: "#202B40"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 50.4229 155.517)",
    fill: "#202B40"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 78.9961 160.063)",
    fill: "#202B40"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 74.3721 160.063)",
    fill: "#202B40"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 77.6084 160.22)",
    fill: "#202B40"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 77.6084 155.517)",
    fill: "#202B40"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 106.183 160.063)",
    fill: "#202B40"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 101.559 160.063)",
    fill: "#202B40"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 104.795 160.22)",
    fill: "#202B40"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 104.795 155.517)",
    fill: "#202B40"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 133.369 160.063)",
    fill: "#202B40"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 128.745 160.063)",
    fill: "#202B40"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 131.981 160.22)",
    fill: "#202B40"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 131.981 155.517)",
    fill: "#202B40"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 160.555 160.063)",
    fill: "#202B40"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 155.931 160.063)",
    fill: "#202B40"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 159.167 160.22)",
    fill: "#202B40"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 159.167 155.517)",
    fill: "#202B40"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 187.741 160.063)",
    fill: "#202B40"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 183.117 160.063)",
    fill: "#202B40"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 186.354 160.22)",
    fill: "#202B40"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 186.354 155.517)",
    fill: "#202B40"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 24.624 185.902)",
    fill: "#202B40"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 20 185.902)",
    fill: "#202B40"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 23.2363 186.059)",
    fill: "#202B40"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 23.2363 181.355)",
    fill: "#202B40"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 51.8105 185.902)",
    fill: "#202B40"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 47.1865 185.902)",
    fill: "#202B40"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 50.4229 186.059)",
    fill: "#202B40"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 50.4229 181.355)",
    fill: "#202B40"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 78.9961 185.902)",
    fill: "#202B40"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 74.3721 185.902)",
    fill: "#202B40"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 77.6084 186.059)",
    fill: "#202B40"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 77.6084 181.355)",
    fill: "#202B40"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 106.183 185.902)",
    fill: "#202B40"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 101.559 185.902)",
    fill: "#202B40"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 104.795 186.059)",
    fill: "#202B40"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 104.795 181.355)",
    fill: "#202B40"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 133.369 185.902)",
    fill: "#202B40"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 128.745 185.902)",
    fill: "#202B40"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 131.981 186.059)",
    fill: "#202B40"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 131.981 181.355)",
    fill: "#202B40"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 160.555 185.902)",
    fill: "#202B40"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 155.931 185.902)",
    fill: "#202B40"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 159.167 186.059)",
    fill: "#202B40"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 159.167 181.355)",
    fill: "#202B40"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 187.741 185.902)",
    fill: "#202B40"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 183.117 185.902)",
    fill: "#202B40"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 186.354 186.059)",
    fill: "#202B40"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 186.354 181.355)",
    fill: "#202B40"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 24.624 211.741)",
    fill: "#202B40"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 20 211.741)",
    fill: "#202B40"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 23.2363 211.898)",
    fill: "#202B40"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 23.2363 207.194)",
    fill: "#202B40"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 51.8105 211.741)",
    fill: "#202B40"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 47.1865 211.741)",
    fill: "#202B40"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 50.4229 211.898)",
    fill: "#202B40"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 50.4229 207.194)",
    fill: "#202B40"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 78.9961 211.741)",
    fill: "#202B40"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 74.3721 211.741)",
    fill: "#202B40"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 77.6084 211.898)",
    fill: "#202B40"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 77.6084 207.194)",
    fill: "#202B40"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 106.183 211.741)",
    fill: "#202B40"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 101.559 211.741)",
    fill: "#202B40"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 104.795 211.898)",
    fill: "#202B40"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 104.795 207.194)",
    fill: "#202B40"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 133.369 211.741)",
    fill: "#202B40"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 128.745 211.741)",
    fill: "#202B40"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 131.981 211.898)",
    fill: "#202B40"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 131.981 207.194)",
    fill: "#202B40"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 160.555 211.741)",
    fill: "#202B40"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 155.931 211.741)",
    fill: "#202B40"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 159.167 211.898)",
    fill: "#202B40"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 159.167 207.194)",
    fill: "#202B40"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 187.741 211.741)",
    fill: "#202B40"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 183.117 211.741)",
    fill: "#202B40"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 186.354 211.898)",
    fill: "#202B40"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 186.354 207.194)",
    fill: "#202B40"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 24.624 237.58)",
    fill: "#202B40"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 20 237.58)",
    fill: "#202B40"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 23.2363 237.737)",
    fill: "#202B40"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 23.2363 233.033)",
    fill: "#202B40"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 51.8105 237.58)",
    fill: "#202B40"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 47.1865 237.58)",
    fill: "#202B40"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 50.4229 237.737)",
    fill: "#202B40"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 50.4229 233.033)",
    fill: "#202B40"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 78.9961 237.58)",
    fill: "#202B40"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 74.3721 237.58)",
    fill: "#202B40"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 77.6084 237.737)",
    fill: "#202B40"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 77.6084 233.033)",
    fill: "#202B40"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 106.183 237.58)",
    fill: "#202B40"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 101.559 237.58)",
    fill: "#202B40"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 104.795 237.737)",
    fill: "#202B40"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 104.795 233.033)",
    fill: "#202B40"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 133.369 237.58)",
    fill: "#202B40"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 128.745 237.58)",
    fill: "#202B40"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 131.981 237.737)",
    fill: "#202B40"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 131.981 233.033)",
    fill: "#202B40"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 160.555 237.58)",
    fill: "#202B40"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 155.931 237.58)",
    fill: "#202B40"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 159.167 237.737)",
    fill: "#202B40"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 159.167 233.033)",
    fill: "#202B40"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 187.741 237.58)",
    fill: "#202B40"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    width: 3.0826,
    height: 1.25422,
    transform: "matrix(1 0 0 -1 183.117 237.58)",
    fill: "#202B40"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 186.354 237.737)",
    fill: "#202B40"
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    width: 3.13555,
    height: 1.23304,
    transform: "matrix(0 1 1 0 186.354 233.033)",
    fill: "#202B40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCardOptionPhysical);
export default __webpack_public_path__ + "static/media/new-card-option-physical.af7ff6f26cb9e3cd30d934c1edb17d34.svg";
export { ForwardRef as ReactComponent };